var _circle, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.1248,
    cy: 50.7,
    r: 47.8602,
    fill: "#EAEEF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.936 30.95C115.2 30.95 117.036 29.1144 117.036 26.85C117.036 24.5856 115.2 22.75 112.936 22.75C110.672 22.75 108.836 24.5856 108.836 26.85C108.836 29.1144 110.672 30.95 112.936 30.95Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.935 14.9496C120.481 14.9496 121.735 13.696 121.735 12.1496C121.735 10.6032 120.481 9.34961 118.935 9.34961C117.388 9.34961 116.135 10.6032 116.135 12.1496C116.135 13.696 117.388 14.9496 118.935 14.9496Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9852 10.4C19.857 10.4 22.1852 8.07189 22.1852 5.2C22.1852 2.32812 19.857 0 16.9852 0C14.1133 0 11.7852 2.32812 11.7852 5.2C11.7852 8.07189 14.1133 10.4 16.9852 10.4Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6336 24.6251H52.1387V14.9497H85.5585C85.6199 14.9497 85.6813 14.9497 85.7428 14.9497C90.9646 15.073 95.2035 19.3868 95.2035 24.6251H84.1455",
    fill: "#CCD4E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_28_15648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.4794 14.9497C84.5135 15.073 82.6705 15.8741 81.3804 17.2299C81.2575 17.3532 81.1347 17.4764 81.0118 17.6613C79.8446 19.0171 78.9845 20.8043 78.9845 22.7147V80.2743C78.9845 85.6358 74.6842 89.9497 69.3395 89.9497H22.4043V22.2833C22.5272 20.3113 23.2644 18.5241 24.5545 17.2299C25.9674 15.8125 27.8719 14.9497 30.022 14.9497H77.2644H86.2337C86.2951 14.9497 86.3565 14.9497 86.4794 14.9497Z",
    fill: "url(#paint0_linear_28_15648)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6462 28.1379H55.7008C55.2093 28.1379 54.7793 27.7065 54.7793 27.2135C54.7793 26.7205 55.2093 26.2891 55.7008 26.2891H69.6462C70.1377 26.2891 70.5677 26.7205 70.5677 27.2135C70.5677 27.7065 70.1991 28.1379 69.6462 28.1379Z",
    fill: "#B3BFD3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1283 28.1379H30.944C30.4525 28.1379 30.0225 27.7065 30.0225 27.2135C30.0225 26.7205 30.4525 26.2891 30.944 26.2891H49.1897C49.6812 26.2891 50.1112 26.7205 50.1112 27.2135C50.1112 27.7065 49.6812 28.1379 49.1283 28.1379Z",
    fill: "#B3BFD3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8002 37.2585H42.6774C42.1859 37.2585 41.7559 36.8271 41.7559 36.3341C41.7559 35.8411 42.1859 35.4097 42.6774 35.4097H60.8002C61.2917 35.4097 61.7217 35.8411 61.7217 36.3341C61.7832 36.8271 61.3531 37.2585 60.8002 37.2585Z",
    fill: "#B3BFD3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8416 37.2585H30.944C30.4525 37.2585 30.0225 36.8271 30.0225 36.3341C30.0225 35.8411 30.4525 35.4097 30.944 35.4097H36.8416C37.333 35.4097 37.7631 35.8411 37.7631 36.3341C37.7631 36.8271 37.333 37.2585 36.8416 37.2585Z",
    fill: "#D4DBEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6464 46.3796H58.527C58.0355 46.3796 57.6055 45.9482 57.6055 45.4552C57.6055 44.9622 58.0355 44.5308 58.527 44.5308H69.6464C70.1379 44.5308 70.5679 44.9622 70.5679 45.4552C70.5679 45.9482 70.1993 46.3796 69.6464 46.3796Z",
    fill: "#D4DBEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1829 46.3796H30.944C30.4525 46.3796 30.0225 45.9482 30.0225 45.4552C30.0225 44.9622 30.4525 44.5308 30.944 44.5308H53.1829C53.6743 44.5308 54.1044 44.9622 54.1044 45.4552C54.1044 45.9482 53.7358 46.3796 53.1829 46.3796Z",
    fill: "#B3BFD3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8001 55.5002H48.5748C48.0834 55.5002 47.6533 55.0688 47.6533 54.5758C47.6533 54.0828 48.0834 53.6514 48.5748 53.6514H60.8001C61.2915 53.6514 61.7216 54.0828 61.7216 54.5758C61.783 55.0688 61.353 55.5002 60.8001 55.5002Z",
    fill: "#B3BFD3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2307 55.5002H30.944C30.4525 55.5002 30.0225 55.0688 30.0225 54.5758C30.0225 54.0828 30.4525 53.6514 30.944 53.6514H43.2921C43.7836 53.6514 44.2136 54.0828 44.2136 54.5758C44.2136 55.0688 43.7836 55.5002 43.2307 55.5002Z",
    fill: "#D4DBEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6463 64.6213H61.107C60.6156 64.6213 60.1855 64.1899 60.1855 63.6969C60.1855 63.2039 60.6156 62.7725 61.107 62.7725H69.6463C70.1378 62.7725 70.5678 63.2039 70.5678 63.6969C70.5678 64.1899 70.1992 64.6213 69.6463 64.6213Z",
    fill: "#B3BFD3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5783 64.6213H41.2643C40.7728 64.6213 40.3428 64.1899 40.3428 63.6969C40.3428 63.2039 40.7728 62.7725 41.2643 62.7725H55.5783C56.0697 62.7725 56.4998 63.2039 56.4998 63.6969C56.4998 64.1899 56.0697 64.6213 55.5783 64.6213Z",
    fill: "#D4DBEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9201 64.6213H30.944C30.4525 64.6213 30.0225 64.1899 30.0225 63.6969C30.0225 63.2039 30.4525 62.7725 30.944 62.7725H35.9201C36.4115 62.7725 36.8416 63.2039 36.8416 63.6969C36.8416 64.1899 36.4115 64.6213 35.9201 64.6213Z",
    fill: "#B3BFD3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7997 73.7419H52.3219C51.8304 73.7419 51.4004 73.3105 51.4004 72.8175C51.4004 72.3245 51.8304 71.8931 52.3219 71.8931H60.7997C61.2912 71.8931 61.7212 72.3245 61.7212 72.8175C61.7826 73.3105 61.3526 73.7419 60.7997 73.7419Z",
    fill: "#B3BFD3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7324 73.7419H30.944C30.4525 73.7419 30.0225 73.3105 30.0225 72.8175C30.0225 72.3245 30.4525 71.8931 30.944 71.8931H46.7324C47.2238 71.8931 47.6539 72.3245 47.6539 72.8175C47.6539 73.3105 47.2238 73.7419 46.7324 73.7419Z",
    fill: "#D4DBEC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6981 82.3081H61.1077C61.1077 84.4034 61.9677 86.3139 63.3193 87.6697C64.6708 89.0871 66.5752 89.8882 68.664 89.8882H12.821C10.7322 89.8882 8.82779 89.0255 7.47625 87.6697C6.12472 86.3139 5.26465 84.4034 5.26465 82.3081H42.0019C42.0019 82.3081 48.821 82.3697 48.6981 82.3081Z",
    fill: "#CCD4E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101.973 76.4062L94.2168 68.6556L95.995 66.8774L103.746 74.6341L101.973 76.4062Z",
    fill: "#858B9B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104.67 79.1333L98.7221 73.1855C98.2254 72.6888 98.2254 71.8794 98.7221 71.3828C99.2188 70.8861 100.028 70.8861 100.525 71.3828L106.473 77.3305C106.969 77.8272 106.969 78.6366 106.473 79.1333C105.976 79.6299 105.167 79.6299 104.67 79.1333Z",
    fill: "#858B9B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.247 79.5133L96.5943 71.8609C96.4165 71.6831 96.4165 71.3949 96.5943 71.211L98.5503 69.2549C98.7281 69.0771 99.0163 69.0771 99.2003 69.2549L106.853 76.9074C107.031 77.0852 107.031 77.3734 106.853 77.5573L104.897 79.5133C104.713 79.6912 104.425 79.6912 104.247 79.5133Z",
    fill: "url(#paint1_linear_28_15648)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4361 43.6812C77.3176 43.6812 70.7383 50.2605 70.7383 58.3789C70.7383 66.4912 77.3176 73.0767 85.4299 73.0767C93.5483 73.0767 100.128 66.4973 100.128 58.3789C100.128 50.2605 93.5483 43.6812 85.4361 43.6812ZM85.4361 70.3542C78.918 70.3542 73.6386 64.9889 73.6386 58.3728C73.6386 51.7566 78.918 46.3975 85.4361 46.3975C91.9541 46.3975 97.2335 51.7628 97.2335 58.3789C97.2335 64.9951 91.948 70.3542 85.4361 70.3542Z",
    fill: "url(#paint2_linear_28_15648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_28_15648",
    x: 0.404297,
    y: 3.94971,
    width: 108.074,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_15648"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_15648",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_15648",
    x1: 54.421,
    y1: 13.2149,
    x2: 54.421,
    y2: 90.7583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_15648",
    x1: 96.4561,
    y1: 74.3853,
    x2: 106.988,
    y2: 74.3853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_15648",
    x1: 70.7248,
    y1: 58.3821,
    x2: 100.133,
    y2: 58.3821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGraphic);
export default __webpack_public_path__ + "static/media/SearchGraphic.310aecbcec7e6c517b601f93583a33e6.svg";
export { ForwardRef as ReactComponent };